import Button from '@mui/material/Button';
import { ComponentProps, PropsWithChildren } from 'react';

interface Props {
	onClick: ComponentProps<typeof Button>['onClick'];
	variant?: ComponentProps<typeof Button>['variant'];
	href?: ComponentProps<typeof Button>['href'];
}

const Action = ({ children, onClick, variant, href }: PropsWithChildren<Props>) => {
	return (
		<Button sx={{ display: 'flex', gap: 1 }} onClick={onClick} variant={variant} href={href}>
			{children}
		</Button>
	);
};

export default Action;
